import { defineComponent as _defineComponent } from 'vue';
import { cn } from '../utils';
import { badgeVariants } from './index';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Badge',
    props: {
        state: { type: null, required: false, default: 'default' },
        variant: { type: null, required: false, default: 'colored' },
        size: { type: null, required: false, default: 'default' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get cn() { return cn; }, get badgeVariants() { return badgeVariants; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
